import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { DashboardIcon, ProductsIcon, IntegrationsIcon, SettingsIcon, InviteIcon } from './SidebarIcons';
import './Sidebar.css';

const Sidebar = ({ isOpen, onToggle }) => {
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const menuItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard',
    },
    {
      key: 'products',
      label: 'Products',
      icon: <ProductsIcon />,
      submenu: [
        { label: 'Add Product', path: '/products/add' },
        { label: 'View Products', path: '/products' },
      ]
    },
    {
      key: 'integrations',
      label: 'Marketplace Integration',
      icon: <IntegrationsIcon />,
      submenu: [
        { label: 'Shopify', path: '/integrations/shopify' },
        { label: 'eBay', path: '/integrations/ebay' },
        { label: 'Poshmark', path: '/integrations/poshmark' },
      ]
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: <SettingsIcon />,
      submenu: [

        { label: 'General', path: '/settings/general' },
        { label: 'eBay Settings', path: '/settings/ebay' },
        { label: 'Shopify Settings', path: '/settings/shopify' },

      ]
    },
    {
      key: 'invite',
      label: 'Users',
      icon: <InviteIcon />,
      path: '/invite-users',
    },
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && isMobile && (
        <div className="sidebar-overlay" onClick={onToggle}></div>
      )}

      {/* Mobile Hamburger Button - Fixed below header when sidebar is closed */}
      {isMobile && !isOpen && (
        <button
          className="mobile-sidebar-toggle"
          onClick={onToggle}
          aria-label="Open sidebar"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        {/* Sidebar Header */}
        <div className="sidebar-header">
          {isMobile && isOpen ? (
            <div className="sidebar-mobile-header">
              <button
                className="sidebar-close-btn"
                onClick={onToggle}
                aria-label="Close sidebar"
              >
                ×
              </button>
            </div>
          ) : (
            <>
              {!isOpen ? (
                <button
                  className="sidebar-hamburger-btn"
                  onClick={onToggle}
                  aria-label="Open sidebar"
                >
                  <span className="hamburger-line"></span>
                  <span className="hamburger-line"></span>
                  <span className="hamburger-line"></span>
                </button>
              ) : (
                <button
                  className="sidebar-close-btn desktop"
                  onClick={onToggle}
                  aria-label="Close sidebar"
                >
                  ×
                </button>
              )}
            </>
          )}
        </div>

        {/* Navigation Menu */}
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <div key={item.key}>
              {item.submenu ? (
                // Menu item with submenu
                <>
                  <button
                    className={`sidebar-item sidebar-toggle ${expandedMenus[item.key] ? 'expanded' : ''}`}
                    onClick={() => toggleSubmenu(item.key)}
                  >
                    <span className="sidebar-icon">{item.icon}</span>
                    {isOpen && (
                      <>
                        <span className="sidebar-label">{item.label}</span>
                        <span className="sidebar-arrow">
                          {expandedMenus[item.key] ? '▼' : '▶'}
                        </span>
                      </>
                    )}
                  </button>

                  {expandedMenus[item.key] && isOpen && (
                    <div className="sidebar-submenu">
                      {item.submenu.map((subItem) => (
                        <NavLink
                          key={subItem.path}
                          to={subItem.path}
                          className={({ isActive }) =>
                            `sidebar-subitem ${isActive ? 'active' : ''}`
                          }
                        >
                          {subItem.label}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                // Simple menu item
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sidebar-item ${isActive ? 'active' : ''}`
                  }
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  {isOpen && <span className="sidebar-label">{item.label}</span>}
                </NavLink>
              )}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
